import React from 'react';

function AlertBanner({ message }) { // Accept a "message" prop
  const bannerStyle = {
    backgroundColor: '#0b3d90',
    color: 'white',
    width: '100%',
    padding: '2px',
    textAlign: 'center',
    justifyContent: 'center',
  };

  if (message) {
    return (
      <div style={bannerStyle}>
        <span>
          <h4>{message}</h4>
        </span>
      </div>
    );
  }
  return <></>
}

export default AlertBanner;
